import React from 'react';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';
import { RealizedGainLossDTO } from '../../../../../../api/useRealizedGainLossQuery';
import { DesktopInvestmentTable } from './components/DesktopInvestmentTable/DesktopInvestmentTable';
import { MobileInvestmentTable } from './components/MobileInvestmentTable/MobileInvestmentTable';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  investments: RealizedGainLossDTO[];
}

export const InvestmentTable = ({ investments }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isEmbeddedMobile) {
    return <MobileInvestmentTable investments={investments} />;
  }

  return (
    <Box display="flex" flexDirection="column" gridGap="24">
      {investments.map(investment => (
        <DesktopInvestmentTable investment={investment} />
      ))}
    </Box>
  );
};
